export default "__VITE_ASSET__5a25b302__"